export class IUserLocalDetails {
  userToken = '';
  userId = '';
  email = '';
  inksoftUserId = '';
  role: 'StoreAdmin'|'SuperAdmin'|'CustomerService'|'EndUser'|'StoreOwner'|'StoreStaffMember'|'' = '';
  profileImage = '';
  profileName = '';
  inksoftToken = '';
  companyId = '';
}
